window.onWizzyScriptLoaded = function() {
  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(data) {
      data.search.configs.pagination.appendInExistingList = true;
      data.search.configs.facets.showPriceInputRangeFields = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data?.search?.configs?.facets?.configs?.forEach((facetConfig) => {
        if(facetConfig.key === "discountPercentage") {
          facetConfig.config = {
            interval: 10
          }
        }
      });
      return data;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function(data) {
      data.search.configs.pagination.appendInExistingList = true;
      data.search.configs.facets.showPriceInputRangeFields = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data?.search?.configs?.facets?.configs?.forEach((facetConfig) => {
        if(facetConfig.key === "discountPercentage") {
          facetConfig.config = {
            interval: 10
          }
        }
      });
      return data;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function(data) {
      window.WH_TimeOutForCustomButtonsDetection = 500;
      document.querySelectorAll(".wishlist-hero-custom-button").forEach(function(item) {
          var d = new CustomEvent("wishlist-hero-add-to-custom-element",{
              detail: item
          });
          document.dispatchEvent(d)
      })
      if(window.location.pathname === "/pages/search") {
        const collectionBreadCrumbs = document.querySelector(".page-width-desktop.wz-breadcrum");
        if(collectionBreadCrumbs) {
          // console.log("Hiiiiiiiiiiii");
          collectionBreadCrumbs.style.display = "none";
        }
      }
      initFacetShowMore();
      bindWizzyMobileFilterBehaviour();
      return data;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
      setTimeout(syncAutocompleteWidth, 2);
      return data;
  }, 3);

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(data) {
      const pdpContent = document.querySelector("product-modal.product-media-modal.media-modal");
      const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper.onLeft");
      if(autocomplete) {
        autocomplete.style.display = "none";
      }
      if(pdpContent) {
        pdpContent.style.display = "none";
      }
      if(data.sort && data.sort.length) {
        if(data.sort[0].field === "relevance" && window.wizzyConfig.search.configs.sorts.addBestSellingAsSecondSort) {
          const length = data.sort.length;
          if(data.sort[length-1].field != "product_wizzy-best-selling_sortOrder:float") {
            data.sort.push({
              field: "product_wizzy-best-selling_sortOrder:float",
              order: "asc"
            });
          }
        }
      }
      if(data.facets && data.facets.length) {
        data.facets.forEach((facetConfig) => {
          if(facetConfig.key === "discountPercentage") {
            facetConfig.config = {
              interval: 10
            }
          }
        })
      }
      const collectionBanner = document.querySelector(".collection-hero.collection-hero--with-image");
      if(collectionBanner) {
        collectionBanner.style.display = "none";
      }
      const collectionBreadCrumbs = document.querySelector(".page-width-desktop.wz-breadcrum");
      if(collectionBreadCrumbs) {
        // console.log("Hiiiiiiiiiiii");
        collectionBreadCrumbs.style.display = "none";
      }
      return data;
  },3);

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(products) {
      products.forEach(product => {
          if(product.attributes) {
              product.attributes.forEach(attr => {
                  if (attr.id === "product_tags") {
                      const rawTags = attr.values[0].value;

                      const tags = (Array.isArray(rawTags) ? rawTags.flat() : [rawTags])
                          .join(",")
                          .split(",")
                          .map(tag => tag.trim().toLowerCase())
                          .filter(Boolean);

                      if (tags.includes("free-gift")) {
                          product.hasFreeGift = true;
                      }

                      if (tags.includes("new-arrival")) {
                          product.isNew = true;
                      }

                      if (tags.includes("preorder")) {
                          product.hasPreorder = true;
                      }
                  }
                  else if(attr.id === "product_badge_judgeme") {
                      let divElement = document.createElement("div");
                      divElement.innerHTML = attr.values[0].value[0];
                      // console.log(divElement);
                      product.isOnCategory = window.wizzyConfig.common.isOnCategoryPage;
                      var jdgmPrevBadge = divElement.querySelector(".jdgm-prev-badge");
                      var numberOfReviews = jdgmPrevBadge.getAttribute(
                          "data-number-of-reviews"
                      );
                      var review = jdgmPrevBadge.getAttribute("data-average-rating");
                      if (numberOfReviews > 0) {
                          product.numberOfReviews = numberOfReviews;
                          product.reviewAvailable = true;
                      } else {
                          product.reviewAvailable = false;
                      }
                      product.reviewData = attr.values[0].value[0];
                      product.avgRatings = parseFloat(parseFloat(review).toFixed(1));

                      product.reviewData = function () {
                          return function (text, render) {
                          return render(attr.values[0].value[0]);
                          };
                      };
                  }
                  else if(attr.id === "product_product_flavour_custom") {
                      const flavourHandle = attr.values[0].value[0].toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
                      if(window.product_flavour[flavourHandle] > 0) {
                          product.hasFlavour = true;
                          product.flavourCount = window.product_flavour[flavourHandle];
                      } else {
                          product.flavourCount = 1;
                      }
                  }
              })
          }
          if(product.price) {
              product.price = product.price.replace(/\.00$/, "");
          }
          if(product.sellingPrice) {
              product.sellingPrice = product.sellingPrice.replace(/\.00$/, "");
          }
      })
      return products;
  });

  const targetNode = document.querySelector('.wizzy-body-end-wrapper');

  function updateBodyClass() {
  const autocompleteElement = targetNode.querySelector('.wizzy-autocomplete-wrapper');
  if (
      autocompleteElement &&
      window.getComputedStyle(autocompleteElement).display === 'flex'
  ) {
      document.body.classList.add('wizzy-autocomplete-open');
      document.documentElement.classList.add('wizzy-autocomplete-open');
  } else {
      document.body.classList.remove('wizzy-autocomplete-open');
      document.documentElement.classList.remove('wizzy-autocomplete-open');
  }
  }

  const wizzy_observer_config = { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] };
  const callback = function (mutationsList, observer) {
  for (const mutation of mutationsList) {
      updateBodyClass();
      break; // One update is enough per mutation batch
  }
  };

  const observer = new MutationObserver(callback);
  if (targetNode) {
  observer.observe(targetNode, wizzy_observer_config);
  updateBodyClass();
  }
  window.addEventListener('scroll', function () {
    syncAutocompleteWidth();
});
}

function syncAutocompleteWidth() {
const searchBar = document.querySelector('.search__input.field__input');
const autoComplete = document.querySelector('.wizzy-autocomplete-wrapper');

if (searchBar && autoComplete) {
  const rect = searchBar.getBoundingClientRect();

  const extraWidth = 600;
  const width = searchBar.offsetWidth + extraWidth;
  const left = rect.left - (extraWidth / 2);
  const top = rect.bottom;

  document.documentElement.style.setProperty(
    '--wizzy-autocomplete-width',
    width + 'px'
  );

  document.documentElement.style.setProperty(
    '--wizzy-autocomplete-left',
    left + 'px'
  );

  document.documentElement.style.setProperty(
    '--wizzy-autocomplete-top',
    top + 'px'
  );
}
}

window.addEventListener('load', syncAutocompleteWidth);
window.addEventListener('resize', syncAutocompleteWidth);

function initFacetShowMore() {
document.querySelectorAll('.wizzy-filters-facet-block').forEach((facetBlock) => {
  const facetList = facetBlock.querySelector('.wizzy-facet-list');
  const showMoreButton = facetBlock.querySelector('.button-show-more');

  if (!facetList || !showMoreButton) return;

  const items = facetList.querySelectorAll('.wizzy-facet-list-item');

  // Reset first
  items.forEach((item) => {
    item.style.display = '';
  });

  // If 5 or fewer options, hide Show More button
  if (items.length <= 5) {
    showMoreButton.style.display = 'none';
    return;
  }

  // Show only first 5 options
  items.forEach((item, index) => {
    if (index >= 5) {
      item.style.display = 'none';
    }
  });

  showMoreButton.style.display = '';

  const showMoreLabel = showMoreButton.querySelector('.label-show-more');
  const showLessLabel = showMoreButton.querySelector('.label-show-less');

  showMoreLabel.classList.remove('hidden');
  showLessLabel.classList.add('hidden');

  // Avoid attaching multiple click handlers
  if (showMoreButton.dataset.initialized === 'true') return;

  showMoreButton.dataset.initialized = 'true';

  showMoreButton.addEventListener('click', () => {
    const isExpanded = showMoreButton.dataset.expanded === 'true';

    if (isExpanded) {
      // Show only first 5
      items.forEach((item, index) => {
        item.style.display = index < 5 ? '' : 'none';
      });

      showMoreLabel.classList.remove('hidden');
      showLessLabel.classList.add('hidden');

      showMoreButton.dataset.expanded = 'false';
    } else {
      // Show all
      items.forEach((item) => {
        item.style.display = '';
      });

      showMoreLabel.classList.add('hidden');
      showLessLabel.classList.remove('hidden');

        showMoreButton.dataset.expanded = 'true';
      }
    });
  });
}

function getWizzyNativeApplyButton() {
  return document.querySelector('.wizzy-search-filters-left .wizzy-mobile-filter-buttons .wizzy-apply-all-button')
    || document.querySelector('.wizzy-apply-all-button');
}

function clickWizzyFiltersOverlay() {
  var overlay = document.querySelector('.wizzy-filters-bg');
  if (overlay) overlay.click();
}

function bindWizzyMobileInnerApplyButton() {
  if (window._wizzyMobileApplyCloseBound) return;
  window._wizzyMobileApplyCloseBound = true;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var innerApplyButton = e.target.closest('.wz-filter-apply-sub-button');
    if (!innerApplyButton) return;

    var applyButton = getWizzyNativeApplyButton();
    if (applyButton) applyButton.click();
  });
}

function bindWizzyMobileCloseSvgClose() {
  if (window._wizzyMobileSvgCloseBound) return;
  window._wizzyMobileSvgCloseBound = true;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var svgButton = e.target.closest('.wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left button.mobile-facets__close-button .mobile-facets__close');
    if (!svgButton) return;
    clickWizzyFiltersOverlay();
  });
}

function bindWizzySubClearFilterButton() {
  if (window._wizzySubClearFilterBound) return;
  window._wizzySubClearFilterBound = true;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var innerSubClearButton = e.target.closest('.wz-sub-clear-filter-button');
    if (!innerSubClearButton) return;

    e.preventDefault();

    var facetBody = innerSubClearButton.closest('.wizzy-facet-body');
    if (!facetBody) return;

    facetBody.querySelectorAll('.wizzy-facet-list-item.active, .wizzy-facet-list-item.selected').forEach(function (item) {
      item.click();
    });

    var applyButton = facetBody.querySelector('.wz-filter-apply-sub-button');
    if (applyButton) applyButton.click();
  });
}

function bindWizzyMobileFacetBackButton() {
  if (window._wizzyMobileFacetBackBound) return;
  window._wizzyMobileFacetBackBound = true;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var button = e.target.closest('.wizzy-facet-body .mobile-facets__close-button');
    if (!button) return;

    var firstSvg = button.querySelector('svg:first-of-type');
    if (!firstSvg || !firstSvg.contains(e.target)) return;

    var selectedFacetHead = document.querySelector('.wizzy-facet-head.wizzy-selected-facet');
    if (selectedFacetHead) selectedFacetHead.classList.remove('wizzy-selected-facet');

    var facetBody = button.closest('.wizzy-facet-body');
    if (facetBody) facetBody.style.display = 'none';
  });
}

function bindWizzyMobileFacetHeaderClose() {
  if (window._wizzyMobileFacetCloseOnBackAndCloseButtonBound) return;
  window._wizzyMobileFacetCloseOnBackAndCloseButtonBound = true;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var svgButton = e.target.closest('.wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left .wizzy-filters-header .mobile-facets__close');
    if (!svgButton) return;
    clickWizzyFiltersOverlay();
  });
}

function bindWizzyMobileFacetClearAllFilters() {
  if (window._wizzyMobileFacetClearAllFiltersBound) return;
  window._wizzyMobileFacetClearAllFiltersBound = true;

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var clearAllFiltersButton = e.target.closest('.wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left .wz-clear-all-filter-button');
    if (!clearAllFiltersButton) return;

    var actualClearAllButton = document.querySelector('.wizzy-filters-clear-all');
    if (actualClearAllButton) {
      actualClearAllButton.click();
    } else {
      clickWizzyFiltersOverlay();
    }
  });
}

function bindWizzyMobileFilterBehaviour() {
  bindWizzyMobileInnerApplyButton();
  bindWizzyMobileCloseSvgClose();
  bindWizzySubClearFilterButton();
  bindWizzyMobileFacetBackButton();
  bindWizzyMobileFacetHeaderClose();
  bindWizzyMobileFacetClearAllFilters();
}

bindWizzyMobileFilterBehaviour();

